import { render, staticRenderFns } from "./DefaultBalanceHeader.vue?vue&type=template&id=d6932150"
import script from "./DefaultBalanceHeader.vue?vue&type=script&lang=js"
export * from "./DefaultBalanceHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/www-root/data/www/view.sessiondesign.ru/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6932150')) {
      api.createRecord('d6932150', component.options)
    } else {
      api.reload('d6932150', component.options)
    }
    module.hot.accept("./DefaultBalanceHeader.vue?vue&type=template&id=d6932150", function () {
      api.rerender('d6932150', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/front/shared/views/layouts/partials/DefaultBalanceHeader.vue"
export default component.exports